enum BrandEnum {
  IMAGINELEARNING = "assets:icons/my-path-logo.svg",
  MY_PATH = "assets:icons/my-path.svg"
}
export default BrandEnum;
